import { defineStore } from "pinia"
import { ref, computed } from "vue"
import { getAudio } from "@/api/s3/index"
import type { Ref } from "vue"
import type { Question } from "@/features/swipe/store/swipe.types.js"

export const useQuestionsStore = defineStore("swipeQuestionsStore", () => {
  const items: Ref<Question[]> = ref([])
  const currentIndex: Ref<number> = ref(0)
  const isLastQuestion: Ref<boolean> = ref(false)

  const currentQuestion = computed<Question>(() => {
    return items.value[currentIndex.value]
  })
  const questionsLength = computed(() => items.value.length)

  function setCurrentIndex(id: number) {
    currentIndex.value = id
  }

  function fetchAudios() {
    getAudio({ test: "swipe" })
  }

  return {
    questions: items.value,
    currentIndex,
    currentQuestion,
    questionsLength,
    isLastQuestion,
    fetchAudios,
    setCurrentIndex,
  }
})
